// @flow
import React, { Suspense, lazy } from 'react';

import { Switch } from 'react-router-dom';
import Route from './components/helpers/router/Route';
import PrivateRoute from './components/helpers/router/PrivateRoute';


import AnimatedLogo from './components/AnimatedLogo'
import NotFound from './components/NotFound'

import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import Redeem from './components/auth/Redeem';
import Reset from './components/auth/Reset';

import PixelSets from './components/PixelSets/index';
// import Links from './components/Links/index';

// Modals
import { Modals } from './components/modals';

import NewProjectModal from './components/Projects/newModal';
import EditProjectModal from './components/Projects/editModal';

import NewPixelSetModal from './components/PixelSets/newModal';
import EditPixelSetModal from './components/PixelSets/editModal';

import NewLinkModal from './components/Links/newModal';
import EditLinkModal from './components/Links/editModal';
import CloneLinkModal from './components/Links/cloneModal';
import ShareLinkModal from './components/Links/ShareLinkModal';


import NewMessengerLinkModal from './components/MessengerLinks/newModal';
import EditMessengerLinkModal from './components/MessengerLinks/editModal';


import SignupModal from './components/auth/signupModal';
import ActivateModal from './components/billing/activateModal';
import AddPaymentMethodModal from './components/billing/addPaymentMethodModal';

import EditProfileModal from './components/Profile/editModal';

// Containers
import AuthPage from './containers/AuthPage'
import UnauthPage from './containers/UnauthPage'
import BlankLogoPage from './containers/BlankLogoPage'
import SmartPageContainer from './containers/SmartPageContainer'
import AdminPage from './containers/AdminPage'

import Loading from './components/helpers/Loading';

import plans from './components/billing/plans';

// import Profile from './components/Profile';
// import Home from './components/Home';
const Profile  = lazy(() => import('./components/Profile'));
const Home  = lazy(() => import('./components/Home'));

// const Pricing  = lazy(() => import('./components/billing/pricing'));
const ActivateSubscription  = lazy(() => import('./components/billing/ActivateSubscription'));
const CheckoutForm  = lazy(() => import('./components/billing/CheckoutForm'));

// BioLinks
// import BioLinkFTE from './components/SmartLinks/BioLinkFTE';
// import NewBioLink from './components/SmartLinks/NewBioLink';
// import ImportSmartPage from './components/SmartLinks/ImportSmartPage';
// import EditBioLink from './components/SmartLinks/EditBioLink';
const BioLinkFTE  = lazy(() => import('./components/SmartLinks/BioLinkFTE'));
const NewBioLink  = lazy(() => import('./components/SmartLinks/NewBioLink'));
const EditBioLink  = lazy(() => import('./components/SmartLinks/EditBioLink'));

// MessengerLinks
// import NewMessengerLink from './components/MessengerLinks/NewMessengerLink';
const NewMessengerLink  = lazy(() => import('./components/MessengerLinks/NewMessengerLink'));

// Pages
//import NewSmartPage from './components/SmartPages/NewSmartPage';
//import EditSmartPage from './components/SmartPages/EditSmartPage';
const NewSmartPage = lazy(() => import('./components/SmartPages/NewSmartPage'));
const EditSmartPage = lazy(() => import('./components/SmartPages/EditSmartPage'));
const ImportSmartPage  = lazy(() => import('./components/SmartPages/ImportSmartPage'));
const SpecialPage  = lazy(() => import('./components/SmartPages/SpecialPage'));

export default function RouterConfig() {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path="/login" component={Login} container={UnauthPage} />
        <Route exact path="/signup" component={Signup} container={UnauthPage} />
        <Route exact path="/redeem" component={Redeem} container={UnauthPage} />
    
        <Route exact path="/reset" component={Reset} container={UnauthPage} />
        <Route exact path="/logo" component={AnimatedLogo} />
      
        <PrivateRoute exact path="/" component={Home} container={AuthPage} />
        <PrivateRoute exact path="/profile" component={Profile} container={AuthPage} />
        <PrivateRoute exact path="/pixels" component={PixelSets} container={AuthPage} />
        <PrivateRoute exact path="/biolinks/new" component={NewBioLink} container={AuthPage} />
        <PrivateRoute exact path="/biolinks/fte" component={BioLinkFTE} container={AuthPage} />
        <PrivateRoute exact path="/biolinks/:id" component={EditBioLink} container={AuthPage} />
        
        <Route exact path="/smartpage" component={NewSmartPage} container={SmartPageContainer} />
        <Route exact path="/page" component={NewSmartPage} container={SmartPageContainer} />
        <PrivateRoute exact path="/smartpages/:id" component={EditSmartPage} container={SmartPageContainer} />
        <PrivateRoute exact path="/pages/:id" component={EditSmartPage} container={SmartPageContainer} />
        <Route exact path="/fromlinktree" component={ImportSmartPage} />
        <Route exact path="/import" component={ImportSmartPage} />
        <Route exact path="/page/:special_k" component={SpecialPage} />
        <Route exact path="/bio" component={NewSmartPage} container={SmartPageContainer} />
        
        <Route exact path="/createbio" component={NewBioLink} container={BlankLogoPage} />
        <Route exact path="/newbio" component={NewBioLink} container={BlankLogoPage} />
        <Route exact path="/newmessenger" component={NewMessengerLink} container={BlankLogoPage} />
      
        
        <PrivateRoute exact path="/activate" component={() => <ActivateModal isOpen={true} size="lg" />} container={AuthPage} />
        
        <Route exact path="/pricing" component={ActivateSubscription} container={BlankLogoPage} />
        <Route exact path="/upgrade" component={ActivateSubscription} container={BlankLogoPage} />
        <PrivateRoute signup path={`/upgrade/:plan_id(${Object.keys(plans).join('|')}|${Object.keys(plans).join('_annual|')}_annual|${Object.keys(plans).join('_monthly|')}_monthly)`} component={CheckoutForm} container={BlankLogoPage} />
        
        <PrivateRoute isAdmin exact path="/admin/updates" component={AdminPage} />
        
        <Route component={NotFound} container={UnauthPage} />
      </Switch>
    </Suspense>
  )
}
//  <Route exact path="/bio" component={BioLinkFTE} container={BlankLogoPage} />

export const modalRouter = {
  newProject: NewProjectModal,
  editProject: EditProjectModal,
  
  newPixelSet: NewPixelSetModal,
  editPixelSet: EditPixelSetModal,
  
  newLink: NewLinkModal,
  editLink: EditLinkModal,
  cloneLink: CloneLinkModal,
  shareLink: ShareLinkModal,
  
  newMessengerLink: NewMessengerLinkModal,
  editMessengerLink: EditMessengerLinkModal,
  
  signup: SignupModal,
  activate: ActivateModal,
  editProfile: EditProfileModal,
  addPaymentMethod: AddPaymentMethodModal
}

export function ModalRouterConfig() {
  return (<Modals />)
}


// WEBPACK FOOTER //
// ./src/router.js